"use strict";

define('uikit/elements/label',['underscore', 'marionette', '../mixins/component.mixin', '../channel', '../templates', '../extra/size', '../extra/color'], function (_, Mn, ComponentMixin, channel, Templates, Size, Color) {
  var LabelView = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'ui label',
    allowTagChange: true,
    options: {
      visible: true,
      text: '',
      link: '',
      detail: '',
      icon: null,
      pointing: null,
      prompt: false,
      attached: null,
      horizontal: false,
      floating: false,
      color: '',
      size: '',
      circular: false,
      tag: false,
      empty: false,
      ribbon: false,
      wrappable: false,
      closeable: false,
      title: ''
    },
    pointingOptionValues: ['below', 'left', 'right', 'above'],
    attachedOptionValues: ['top', 'top right', 'bottom', 'bottom right'],
    sizeOptionValues: _.values(Size),
    colorOptionValues: _.values(Color),
    update: {
      wrappable: false,
      title: false
    },
    events: {
      'click i.close.icon': function click_iCloseIcon() {
        this.triggerMethod('close');
      },
      'keydown i.close.icon': function keydown_iCloseIcon(ev) {
        if (ev.keyCode == 13) {
          this.triggerMethod('close');
        }
      }
    },
    updateAttributes: function updateAttributes() {
      this.addClass("icon", this.getBoolOption("icon") && !this.getBoolOption('text')).addClass("floating", this.getBoolOption("floating")).addClass("circular", this.getBoolOption("circular")).addClass("tag", this.getBoolOption("tag")).addClass(this.getOption("attached"), this.getBoolOption("attached")).addClass("horizontal", this.getBoolOption("horizontal")).addClass("pointing", this.getBoolOption("pointing")).addClass("prompt", this.getBoolOption("prompt")).addClass("empty", this.getBoolOption("empty")).addClass("ribbon", this.getBoolOption("ribbon")).addClass('wrappable', this.getBoolOption('wrappable')).addClass(this.getOption("pointing"), this.getBoolOption("pointing")).addClass(this.getOption('color')).addClass(this.getOption('size'));
      if (this.getOption('link')) {
        this.$el.attr('href', this.getOption('link'));
      } else {
        this.$el.removeAttr('href');
      }
      if (this.title) {
        this.$el.attr('title', this.title);
      } else {
        this.$el.removeAttr('title');
      }
    },
    template: Templates.UIKit['label']
  });
  channel.reply('label', function () {
    return LabelView;
  });
  return LabelView;
});

